// Copyright (c) StrangeBee 2023

import { THTooltip } from '@Molecules/THTooltip/THTooltip';
import React, { ReactElement } from 'react';

import './Shortify.scss';

interface ShortifyProps {
    line: string;
    maxSize?: number;
}

const Shortify = ({ line = '', maxSize = 15 }: ShortifyProps): ReactElement => {
    if (line.length > maxSize) {
        const lineProcessed = line.substring(0, maxSize) + '...';
        return (
            <THTooltip title={line}>
                <span className="shortify">{lineProcessed}</span>
            </THTooltip>
        );
    }

    return <span className="shortify">{line}</span>;
};

export default Shortify;
